// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoPlayer_root__p3qkZ","play":"VideoPlayer_play__HQtFx"};